const RuleKey = {
  // Anterior Tibial / Posterior Tibial / Peroneal / Tibioperoneal Trunk
  37228: {
    value: "balloon-angioplasty",
    check: "Anterior Tibial / Posterior Tibial / Peroneal / Tibioperoneal Trunk",
  },
  37229: {
    value: "directional-atherectomy > balloon-angioplasty",
    check: "Anterior Tibial / Posterior Tibial / Peroneal / Tibioperoneal Trunk",
  },
  37230: {
    value: "balloon-angioplasty > self-expanding-stent",
    check: "Anterior Tibial / Posterior Tibial / Peroneal / Tibioperoneal Trunk",
  },
  37231: {
    value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
    check: "Anterior Tibial / Posterior Tibial / Peroneal / Tibioperoneal Trunk",
  },
  // SFA/Popliteal / Common Femoral / Common Iliac
  37224: {
    value: "balloon-angioplasty",
    check: "SFA/Popliteal / Common Femoral",
  },
  37225: {
    value: "directional-atherectomy > balloon-angioplasty",
    check: "SFA/Popliteal / Common Femoral",
  },
  37226: {
    value: "balloon-angioplasty > self-expanding-stent",
    check: "SFA/Popliteal / Common Femoral",
  },
  37227: {
    value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
    check: "SFA/Popliteal / Common Femoral",
  },
  // External Iliac / Internal Iliac
  37220: {
    value: "balloon-angioplasty",
    check: "External Iliac / Internal Iliac / Common Iliac",
  },
  37221: {
    value: "balloon-angioplasty > self-expanding-stent",
    check: "External Iliac / Internal Iliac / Common Iliac",
  },
  //
  37232: {
    value: "balloon-angioplasty",
    check: "Anterior Tibial / Posterior Tibial / Peroneal / Tibioperoneal Trunk",
  },
  37233: {
    value: "directional-atherectomy > balloon-angioplasty",
    check: "Anterior Tibial / Posterior Tibial / Peroneal / Tibioperoneal Trunk",
  },
  37234: {
    value: "balloon-angioplasty > self-expanding-stent",
    check: "Anterior Tibial / Posterior Tibial / Peroneal / Tibioperoneal Trunk",
  },
  37235: {
    value: "directional-atherectomy > balloon-angioplasty > self-expanding-stent",
    check: "Anterior Tibial / Posterior Tibial / Peroneal / Tibioperoneal Trunk",
  },
  37222: {
    value: "balloon-angioplasty",
    check: "External Iliac / Internal Iliac / Common Iliac",
  },
  37223: {
    value: "balloon-angioplasty > self-expanding-stent",
    check: "External Iliac / Internal Iliac / Common Iliac",
  },
};

export default RuleKey;
